// extracted by mini-css-extract-plugin
module.exports = {"requiredFieldsText":"BusinessDetails_requiredFieldsText__21XFF"};